import { render } from "./EmptyNotifications.vue?vue&type=template&id=336ef862"
import script from "./EmptyNotifications.vue?vue&type=script&lang=js"
export * from "./EmptyNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__